export class Course {
    front = new Array<GolfHole>(9);
    back= new Array<GolfHole>(9);
    parFront: number;
    parBack: number;
    slope: number;
    rating: number;
    tees_id: string;
}

export class GolfHole {
    holeNumber: number;
    handicap: number;
    yards: number;
    par: number;
    
}

export class CourseListItem {
    tees_id: string;
    teename: string;
    course_id: string;
    stateorregion: string; 
    coursename: string;
    count: string;
    avg_score: string;
}

